module.exports = __webpack_public_path__ + "img/point_arrow.16a7baa9.svg";